module.exports = __webpack_public_path__ + "img/Bedroom02.94863efe.png";